import { useMediaQuery } from "@mui/system";
import Logo from "./Logo";

function Footer() {

  const isDesktop = useMediaQuery("(min-width: 720px)");

  return (
    <div id="footer" className="footer">
      <div className="content-container">
        <Logo color="#c09c72" size="25px" />
        <h1>KALYANAM</h1>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
          {!isDesktop &&
            <>
              <h2
                style={{ fontSize: "0.9rem", cursor: "pointer" }}
                onClick={() => window.location.href = "instagram://user?username=kalyanam.dk"}
              >
                INSTAGRAM
              </h2>

              <h2 style={{ margin: "0px 15px" }}>|</h2>
            </>
          }
          <h2
            style={{ fontSize: "0.9rem", whiteSpace: "nowrap", cursor: "pointer" }}
            onClick={() => window.location.href = "/about"}
          >
            ABOUT US
          </h2>
        </div>
      </div>
    </div >
  );
}

export default Footer;
